<script lang="typescript">
  import Calendar from './Calendar.svelte';
  import SelectedDay from './SelectedDay.svelte';
  import { service, isCalendarShown } from './store';
  import type { Context } from './store';

  let context:Context;
  $: context = $service.context;
  $: selectedDay = context.selectedDay;
  $: current = $service.machine.current;
  $: currentJson = JSON.stringify(current, null, 2);
  $: showCalendar = isCalendarShown(current);
</script>

<div>
  <!--
  <pre>
  {currentJson}
  </pre>
  <pre>
  {JSON.stringify(selectedDay, null, 2)}
  </pre>
  -->

  <Calendar />

</div>

<style>

</style>
